import { request } from '@/api/http';
import type { MePermissions, MeProfile } from '@/api/types';

export interface AuthLoginResult {
  accessToken: string;
  tokenType: string;
  user: {
    id: string;
    email: string | null;
    role: string;
    plan: string;
    status?: string;
  };
}

export interface AuthRegisterBody {
  name: string;
  email: string;
  password: string;
  termsAccepted: boolean;
}

export interface AuthRegisterResult {
  ok: boolean;
  status: string;
  message: string;
  termsVersion?: string;
  termsAcceptedAt?: string;
}

export interface AuthMeProfile extends MeProfile {
  email?: string | null;
  termsAcceptanceRequired?: boolean;
  currentTermsVersion?: string | null;
  acceptedTermsVersion?: string | null;
}

export const authService = {
  login: (email: string, password: string) =>
    request<AuthLoginResult>('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
      skipAuth: true,
    }),
  register: (body: AuthRegisterBody) =>
    request<AuthRegisterResult>('/auth/register', {
      method: 'POST',
      body: JSON.stringify({
        name: body.name,
        email: body.email,
        password: body.password,
        termsAccepted: body.termsAccepted,
      }),
      skipAuth: true,
    }),
  logout: () => request<{ ok: boolean }>('/auth/logout', { method: 'POST', skipAuth: true }),
  me: () => request<AuthMeProfile>('/auth/me'),
};

export type { MePermissions };
